import React, { useEffect, useState } from 'react';
import Dropdown from '../UI/Dropdown/Dropdown';
import './style.css';
import CategoryIcon from '@material-ui/icons/Category';
import SearchInput from '../UI/inputs/SearchInput';
import Modal from '../UI/modal/Modal';
import AxiosInstance from '../../helpers/AxiosInstance';
import { useTranslation } from 'react-i18next';

const SearchBook = ({ keyword, setKeyword, field, setField, categories = [], setCategories, onClick }) => {
  const { t, i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [listCategories, setListCategories] = useState([]);
  const [searchValue, setSearchValue] = useState('');

  const groupBy = (array, key) => {
    return array.reduce((result, currentValue) => {
      (result[currentValue[key]] = result[currentValue[key]] || []).push(currentValue);
      return result;
    }, {});
  };

  const getCategories = () => {
    AxiosInstance.get('/category').then((response) => {
      const list = response.data.map((item) => {
        return { id: item.children_id, name: item.children_name, parent: item.category_name };
      });
      const nestedList = groupBy(list, 'parent');
      setListCategories(nestedList);
    });
  };

  useEffect(() => {
    getCategories();
  }, []);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleOpen = () => {
    setOpen(true);
  };

  const addCategory = (category) => {
    setCategories([...categories, category.id]);
  };

  const deleteCategory = (id) => {
    const newChoosenCategory = categories.filter((category) => category !== id);
    setCategories(newChoosenCategory);
  };

  const data = () => {
    const listData = [];
    let categoryName = [];
    for (let categoryParent in listCategories) {
      categoryName = listCategories[categoryParent].filter((category) => {
        if (searchValue) {
          return category.name.toLowerCase().includes(searchValue.trim().toLowerCase()) ? true : false;
        }
        return true;
      });

      if (categoryName.length) {
        listData.push(<h5 className="parent-category">{categoryParent}</h5>);
        listData.push(
          categoryName.map((category) => {
            let choosen = categories.filter((itemCategory) => itemCategory === category.id).length ? true : false;
            return (
              <div
                className={choosen ? 'category-item active' : 'category-item'}
                onClick={choosen ? () => deleteCategory(category.id) : () => addCategory(category)}
                key={category.id}
              >
                {category.name}
              </div>
            );
          })
        );
        listData.push(<div className="m-2 w-100" />);
      }
    }
    return listData;
  };

  const body = (
    <div className="category-modal-container">
      <h2 id="simple-modal-title"> {t('search.categories')}</h2>
      <input
        name="category"
        className="input-search-category"
        onChange={(e) => setSearchValue(e.target.value)}
        value={searchValue}
      />
      <div className="list-categories">{data()}</div>
    </div>
  );

  return (
    <div className="search-book-container">
      <div className="category-button-container">
        <button className="category-button" onClick={handleOpen}>
          <CategoryIcon />
          {t('search.categories')}
        </button>
      </div>
      &nbsp; &nbsp;
      <div className="fields-container">
        <Dropdown anchorEl={anchorEl} setAnchorEl={setAnchorEl} handleClick={handleClick} field={field} setField={setField} />
        <div className="search-input-container">
          <SearchInput iconDirection={'right'} keyword={keyword} setKeyword={setKeyword} searchClick={onClick} />
        </div>
      </div>
      <Modal open={open} setOpen={setOpen} body={body} className="search-book-alert-categories-container" />
    </div>
  );
};

export default SearchBook;
